import { lazy, Suspense } from 'react';
import { Location } from 'src/api/device/types';
import { ComponentLoader } from 'src/components/ComponentLoader';

const Map = lazy(() =>
  import('./components/map').then((module) => ({ default: module.Map }))
);

type LazyDeviceMapProps = {
  locations: Location[];
  height?: string;
  popupLabel: string;
};

export const DeviceMap = ({
  locations,
  height,
  popupLabel,
}: LazyDeviceMapProps) => (
  <Suspense fallback={<ComponentLoader height={height} size="lg" />}>
    <Map locations={locations} height={height} popupLabel={popupLabel} />
  </Suspense>
);
